import * as types from './actionTypes';

export const fetchChats = () => ({
  type: types.FETCH_CHATS
});

export const fetchChatsSuccess = (chats) => ({
  type: types.FETCH_CHATS_SUCCESS,
  payload: chats
});

export const addMessage = (channelName, message, from) => ({
  type: types.ADD_MESSAGE,
  payload: { channelName, message, from }
});

export const addMessageSuccess = (chat) => ({
  type: types.ADD_MESSAGE_SUCCESS,
  payload: chat
});